import { ProductLine } from './product-line';
import { MCHAvailableProductLine } from './mchavailableproductline';;

export class Facility {
    public PlantId: number;
    public PlantNumber: number;
    public PlantDesc: string;
    public PlantDescription: string;
    public Selected: boolean;
    public ProductLines: ProductLine[];
    public Collapsed: boolean;
    public ProductLinesCache: ProductLine[];

    constructor() {
        this.ProductLines = new Array<ProductLine>();
        this.ProductLinesCache = new Array<ProductLine>();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/facility.ts